export const setViewItemEventOnDirectSalePageLoad = formWrapperSelector => {
  window.addEventListener('load', () => {
    const formWrapper = document.querySelector(formWrapperSelector);

    if (!formWrapper) return;

    const directSalesData = JSON.parse(formWrapper.dataset.directSaleData);

    const adaptedItem =
      window.DDMDataLayerHelpers.DirectSalesAdapter.adaptItem(directSalesData);

    window.DDMDataLayerService.addViewItemEvent(adaptedItem);
  });
};
